import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Api from "../../services/api";
import { useForm, Controller } from "react-hook-form";
import swal from "sweetalert";

const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link", "image"],
    [{ color: [] }, { background: [] }],
    ["blockquote", "code-block"],
    ["clean"],
  ],
};

const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "align",
  "link",
  "image",
  "color",
  "background",
  "blockquote",
  "code-block",
];

function ConteudoEditor({ value, onChange }) {
  const [showSource, setShowSource] = useState(false);

  return (
    <div className="conteudo-editor">
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 4 }}>
        <button
          type="button"
          onClick={() => setShowSource((s) => !s)}
          style={{
            fontSize: 12,
            padding: "4px 10px",
            cursor: "pointer",
            border: "1px solid #ccc",
            background: showSource ? "#333" : "#f5f5f5",
            color: showSource ? "#fff" : "#333",
            borderRadius: 3,
          }}
        >
          {showSource ? "Modo visual" : "</> Editar HTML"}
        </button>
      </div>
      {showSource ? (
        <textarea
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          spellCheck={false}
          style={{
            width: "100%",
            minHeight: 320,
            fontFamily: "monospace",
            fontSize: 13,
            padding: 10,
            border: "1px solid #ccc",
            borderRadius: 3,
          }}
        />
      ) : (
        <ReactQuill
          theme="snow"
          value={value || ""}
          onChange={onChange}
          modules={quillModules}
          formats={quillFormats}
          style={{ minHeight: 300 }}
        />
      )}
    </div>
  );
}

export default function EditConteudo({
  data,
  setOpenModalEditConteudo,
  loadUnidades,
}) {
  const [loading, setLoading] = useState(false);
  const Loader = () => <div className="loading"></div>;
  const { control, handleSubmit, setValue } = useForm({
    defaultValues: {
      id: data.id,
      conteudo_pt: data.conteudo_pt || "",
      conteudo_en: data.conteudo_en || "",
      conteudo_es: data.conteudo_es || "",
    },
  });

  useEffect(() => {
    setValue("id", data.id);
    setValue("conteudo_pt", data.conteudo_pt || "");
    setValue("conteudo_en", data.conteudo_en || "");
    setValue("conteudo_es", data.conteudo_es || "");
  }, [data, setValue]);

  const onSubmit = (formData) => {
    setLoading(true);

    Api.post("/unidades/editconteudo", formData)
      .then((response) => {
        if (response.data.status === "success") {
          swal("Sucesso!", response.data.message, "success");
          loadUnidades();
          setOpenModalEditConteudo(false);
        } else {
          swal("Erro!", response.data.message, "error");
        }
        setLoading(false);
      })
      .catch((err) => {
        swal("Erro!", "ops! ocorreu um erro: " + err, "error");
        setLoading(false);
      });
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <h2>Editar página da unidade</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container className="form">
          <Tabs>
            <TabList>
              <Tab>
                <img src={process.env.PUBLIC_URL + "/images/flag-pt.png"} />
              </Tab>
              <Tab>
                <img src={process.env.PUBLIC_URL + "/images/flag-us.png"} />
              </Tab>
              <Tab>
                <img src={process.env.PUBLIC_URL + "/images/flag-es.png"} />
              </Tab>
            </TabList>
            <TabPanel>
              <Grid item lg={12} md={12} sm={12} sx={12} className="field">
                <label>Conteúdo da página (PT)</label>
                <Controller
                  name="conteudo_pt"
                  control={control}
                  render={({ field }) => (
                    <ConteudoEditor value={field.value} onChange={field.onChange} />
                  )}
                />
              </Grid>
            </TabPanel>
            <TabPanel>
              <Grid item lg={12} md={12} sm={12} sx={12} className="field">
                <label>Conteúdo da página (EN)</label>
                <Controller
                  name="conteudo_en"
                  control={control}
                  render={({ field }) => (
                    <ConteudoEditor value={field.value} onChange={field.onChange} />
                  )}
                />
              </Grid>
            </TabPanel>
            <TabPanel>
              <Grid item lg={12} md={12} sm={12} sx={12} className="field">
                <label>Conteúdo da página (ES)</label>
                <Controller
                  name="conteudo_es"
                  control={control}
                  render={({ field }) => (
                    <ConteudoEditor value={field.value} onChange={field.onChange} />
                  )}
                />
              </Grid>
            </TabPanel>
          </Tabs>
        </Grid>
        <div className="actions" style={{ marginTop: 24 }}>
          <button type="submit" className="save">
            Salvar
          </button>
          <a
            href="#"
            className="cancel"
            onClick={(e) => {
              e.preventDefault();
              setOpenModalEditConteudo(false);
            }}
          >
            Cancelar
          </a>
        </div>
      </form>
    </>
  );
}
